// const withStartSlash = (path) => (path?.startsWith("/") ? path : `/${path}`);
const normalizePathWithQuery = (path) => {
  if (!path.includes("?")) return normalizeRelativePath(path);
  const [pathWithoutQuery, query] = path.split("?");
  return normalizeRelativePath(pathWithoutQuery) + "?" + query;
};
// const normalizeRelativePath = (path) => {
//   const path1 = withStartSlash(path);
//   return path1.endsWith("/") || path1.includes("/#") ? path1 : `${path1}/`;
// };

const normalizeRelativePath = (input) => {
  if (!input) return input;
  const { pathname, search, hash } = new URL(input, "https://www.haier-europe.com");
  const path = pathname.endsWith("/") ? pathname : `${pathname}/`;
  return path + search + hash;
};

const normalizeJoinPaths = (...paths) => {
  return `/${paths
    .map((path) => (path.startsWith("/") ? path.substring(1) : path))
    .map((path) => (path.endsWith("/") ? path.substring(0, path.length - 1) : path))
    .join("/")}/`;
};

const normalizeJoinPathsKeepEnd = (...paths) => {
  const startPaths = paths.slice(0, -1);
  const endPath = paths[paths.length - 1];
  const start = normalizeJoinPaths(...startPaths);
  return `${start}${endPath.startsWith("/") ? endPath.substring(1) : endPath}`;
};

const withEndSlash = (slug) => {
  if (!slug) return slug;
  return slug.endsWith("/") ? slug : `${slug}/`;
};

const linKFromSlug = (slug) =>
  `${slug.startsWith("/") ? "" : "/"}${slug}${slug.endsWith("/") ? "" : "/"}`;

module.exports = {
  normalizeRelativePath,
  normalizeJoinPaths,
  linKFromSlug,
  normalizePathWithQuery,
  normalizeJoinPathsKeepEnd,
  withEndSlash,
};
